import React from 'react';
import { Link, Navigate, Route, Routes } from 'react-router';
import { STUDIO_COPY, isStudioEnabled } from './config';
import StudioLayout from './StudioLayout';
import StudioAuthGate from './components/StudioAuthGate';
import StudioOnboardingGate from './components/StudioOnboardingGate';
import StudioLandingPage from './pages/StudioLandingPage';
import StudioConnectPage from './pages/StudioConnectPage';
import StudioOnboardingPage from './pages/StudioOnboardingPage';
import StudioVodsPage from './pages/StudioVodsPage';
import StudioGeneratePage from './pages/StudioGeneratePage';
import StudioReelPage from './pages/StudioReelPage';
import StudioAccountPage from './pages/StudioAccountPage';
import StudioReelsPage from './pages/StudioReelsPage';
import StudioUpgradePage from './pages/StudioUpgradePage';
import StudioUpgradeSuccessPage from './pages/StudioUpgradeSuccessPage';
import StudioUpgradeCancelPage from './pages/StudioUpgradeCancelPage';
import StudioMySupportPage from './pages/StudioMySupportPage';
import StudioMySupportDetailPage from './pages/StudioMySupportDetailPage';
import StudioAdminSupportPage from './pages/StudioAdminSupportPage';
import StudioAdminSupportDetailPage from './pages/StudioAdminSupportDetailPage';

/**
 * Run The Tape Studios route tree under `/studio/*`.
 * Only mounted from App.tsx when the studio feature flag is on.
 */
const StudioApp: React.FC = () => {
  if (!isStudioEnabled()) {
    return <Navigate to="/" replace />;
  }

  return (
    <Routes>
      <Route element={<StudioLayout />}>
        <Route index element={<StudioLandingPage />} />
        <Route path="landing" element={<StudioLandingPage forceMarketing />} />
        <Route path="connect" element={<StudioConnectPage />} />
        <Route path="upgrade" element={<StudioUpgradePage />} />
        <Route element={<StudioAuthGate />}>
          <Route path="onboarding" element={<StudioOnboardingPage />} />
          <Route element={<StudioOnboardingGate />}>
            <Route path="vods" element={<StudioVodsPage />} />
            <Route path="generate/:vodId" element={<StudioGeneratePage />} />
            <Route path="reel/:jobId" element={<StudioReelPage />} />
            <Route path="reels" element={<StudioReelsPage />} />
            <Route path="account" element={<StudioAccountPage />} />
            <Route path="support" element={<StudioMySupportPage />} />
            <Route path="support/:issueId" element={<StudioMySupportDetailPage />} />
            <Route path="admin/support" element={<StudioAdminSupportPage />} />
            <Route path="admin/support/:issueId" element={<StudioAdminSupportDetailPage />} />
          </Route>
          <Route path="upgrade/success" element={<StudioUpgradeSuccessPage />} />
          <Route path="upgrade/cancel" element={<StudioUpgradeCancelPage />} />
        </Route>
        <Route
          path="*"
          element={
            <div className="studio-panel space-y-4" data-testid="studio-not-found">
              <h1 className="text-2xl font-semibold">{STUDIO_COPY.sceneNotFound}</h1>
              <p className="studio-page-kicker">{STUDIO_COPY.sceneNotFoundBody}</p>
              <Link to="/studio" className="studio-btn-ghost no-underline">
                {STUDIO_COPY.backToStudio}
              </Link>
            </div>
          }
        />
      </Route>
    </Routes>
  );
};

export default StudioApp;
